import defaultTheme from './defaultTheme'
import lightTheme from './lightTheme'
import darkTheme from './darkTheme'

const selectedTheme = (theme) => {
    switch (theme) {
        case 'CLASSIC':
            return defaultTheme
        case 'DARK':
            return darkTheme
        case 'LIGHT':
            return lightTheme
        default:
            break;
    }
}

export default selectedTheme;